import { toWords } from 'number-to-words';
import { PROVIDER_SANDBOX_CONNECTION_LIMIT } from '@finch-api/common/dist/internal/sandbox';
import GenericError from 'pages/Authorize/Errors/GenericError';

const ProviderSandboxConnectionLimit = () => (
  <GenericError buttonLabel="Reload" title="Sandbox Connection Limit">
    {`The Provider Sandbox is limited to ${toWords(
      PROVIDER_SANDBOX_CONNECTION_LIMIT,
    )} connections. Please disconnect an
    existing connection to add a new one.`}
  </GenericError>
);

export default ProviderSandboxConnectionLimit;
